/* eslint-disable import/no-unresolved */
import { mdiClose } from '@mdi/js';

import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { If, Then } from 'react-if';

import ScrollArrow from '../scrollArrow';

import {
  Container,
  Content,
  IconContainer,
  StyledIcon,
  Title,
  HeaderContainer,
  TabsPdfsContainer,
  TabsPdfsItem,
  ContentPdfChildren,
} from './styles';

function Modal(props) {
  const [pdfTab, setPdfTab] = useState(0);
  const {
    onCloseRequest,
    children,
    isOpen,
    width,
    isPdfShowing,
    headerSize,
    title,
    itens,
    onClickItens,
    widthContainer,
    heightContainer,
  } = props;

  return (
    <If condition={isOpen}>
      <Then>
        <Container>
          <Content
            isPdfShowing={isPdfShowing}
            widthContainer={widthContainer}
            heightContainer={heightContainer}
            style={{ maxWidth: width }}
          >
            {isPdfShowing && (
              <>
                <HeaderContainer
                  headerSize={headerSize}
                  isPdfShowing={isPdfShowing}
                >
                  <Title>{title}</Title>
                  <IconContainer
                    isPdfShowing={isPdfShowing}
                    onClick={onCloseRequest}
                  >
                    <StyledIcon size={1.1} icon={mdiClose} color="#9BA8BA" />
                  </IconContainer>
                </HeaderContainer>
                {itens && itens.length > 1 && (
                  <TabsPdfsContainer id="hscroll">
                    {itens.length > 2 && <ScrollArrow />}
                    {itens.map((item, index) => (
                      <TabsPdfsItem
                        isEnabled={pdfTab !== index && true}
                        key={item.id}
                        itensQt={itens.length}
                        onClick={() => {
                          onClickItens(item);
                          setPdfTab(index);
                        }}
                      >
                        {item.title}
                      </TabsPdfsItem>
                    ))}
                  </TabsPdfsContainer>
                )}
              </>
            )}
            {!isPdfShowing && (
              <IconContainer onClick={onCloseRequest}>
                <StyledIcon size={1.1} icon={mdiClose} color="#9BA8BA" />
              </IconContainer>
            )}
            <ContentPdfChildren isPdfShowing={isPdfShowing}>
              {children}
            </ContentPdfChildren>
          </Content>
        </Container>
      </Then>
    </If>
  );
}

Modal.defaultProps = {
  isOpen: false,
};

Modal.propTypes = {
  onCloseRequest: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
    PropTypes.bool,
  ]).isRequired,
  width: PropTypes.bool,
  isPdfShowing: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.bool,
  ]),
  title: PropTypes.string,
  itens: PropTypes.array,
  onClickItens: PropTypes.oneOfType([PropTypes.func]),
  widthContainer: PropTypes.string,
  heightContainer: PropTypes.string,
  headerSize: PropTypes.string,
};
Modal.defaultProps = {
  width: null,
  isPdfShowing: false,
  title: '',
  itens: null,
  onClickItens: null,
  widthContainer: '350px',
  heightContainer: '314px',
  headerSize: '100%',
};

export default Modal;
